import nftAbi from "@/components/abi/nftABI.json";

export const NftContractData = [
  {
    address: "0x703db36FAbD937910B468F9324440b058B0cc7b1", // Blaze with super integrated
    abi: nftAbi,
  },
  {
    address: "0xDF11Da5Db715ac94FEB52558a204b74e553E80bd", // Blaze
    abi: nftAbi,
  },
  {
    address: "0x0C25961D383a2767135aEd86eF8262e35FD4Dca7", // Blaze new
    abi: nftAbi,
  },
  {
    address: "0x8950cab93e64a58E785376762670f0ac8e66C304", // Nova 
    abi: nftAbi,
  },
  {
    address: "0x847019a95840e1812E6Bc2919054e4C0299f7b2c", // Nova Free Mint
    abi: nftAbi,
  },
  {
    address: "0xBe51D8F53E6adB15bbd9864dD409eEa8e706Ba4D", // Alita 
    abi: nftAbi,
  },
  {
    address: "0x15c8cDf4E70ADd0478E07117EBe3Ea25eC9eE640", // Captain Miller
    abi: nftAbi,
  },
  // {
  //   address: "0xBbde03417bBD69C7De4a7DB54D37E2B9AE4166e0", // Blaze sold out
  //   abi: nftAbi,
  // },
  // {
  //   address: "0xa0095311AFc1A2b7b96fDfA895D3Faf0D9384e57", // junglefever old
  //   abi: nftAbi,
  // },
];

export const NftMarketPlaceAddress =
  "0xdF25Fc31d7B352F56c55ae56c1E688889aEbB32d";